export default {
  /**
   * @param state
   * @param items
   */
  setStaffYearlyAttendanceList(state, items) {
    console.log("Items", items);

    state.items = items;
    console.log("Current State ", state);
  },

  /**
   * @param state
   * @param pagination
   */
  setStaffYearlyAttendancePagination(state, pagination) {
    console.log("Pagination", pagination);

    state.pagination = pagination;
    console.log("Current State ", state);
  },

  /**
   * Set the current page
   *
   * @param state
   * @param currentPage
   */
  setStaffYearlyAttendancePage(state, currentPage) {
    console.log("Page to change to", currentPage);

    state.pagination.current_page = currentPage;
  },

  /**
   * Change date filter
   *
   * @param state
   * @param currentDate
   */
  setStaffYearlyAttendanceDate(state, currentDate) {
    console.log("Current Date", currentDate);
    state.filter.date = currentDate;
  },

  /**
   *
   * @param state
   * @param filters
   */
  setStaffYearlyAttendanceFilters(state, filters) {
    console.log(filters);
    state.filter = filters;
  },

  /**
   * Set monthly busy
   *
   * @param state
   * @param isBusy
   */
  setStaffYearlyAttendanceBusy(state, isBusy) {
    console.log(isBusy);
    state.isBusy = isBusy;
  },
};
